import { useEffect } from 'react';

import { useAppDispatch } from '@/shared/hooks';

import { followEncounter } from '../lib';
import { fetchConsultationById } from '../model/transcriptorSlice.thunks';

// Reads the encounter into the store while `active`, through its one poller.
export const useEncounterPolling = ({
  encounterId,
  patientId,
  active,
}: {
  encounterId: string | undefined;
  patientId: string | undefined;
  active: boolean;
}) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!encounterId || !active) {
      return undefined;
    }
    return followEncounter({
      encounterId,
      read: () =>
        dispatch(
          fetchConsultationById({ consultationId: encounterId, patientId }),
        ),
    });
  }, [encounterId, patientId, active]);
};
